var DesignFacade = require('../../../../facade/design/design');
var EditorFacade = require('../../../../facade/editor/editor');
var BaseView = require('./abstract/base');

module.exports = BaseView.extend({
  width: 66,
  height: 66,
  template: require('./templates/shape.hbs'),
  fillColor: '#200E32',
  strokeColor: '#000',

  addElement: function (elementData) {
    INKIVE.DesignFacade.create('shape', _.extend(elementData, {
      content: this.item.path
    }));
  },

  getClickElementData: function (event) {
    var bb = svgedit.utilities.getBBox(this.$draggableClone.find('svg path')[0]);
    var scale = Math.min(this.canvas.contentW, this.canvas.contentH);
    scale /= Math.max(bb.width, bb.height);

    return {
      position: {
        x: (this.canvas.contentW - bb.width * (scale / 2)) / 2,
        y: (this.canvas.contentH - bb.height * (scale / 2)) / 2
      },
      size: {
        width: bb.width * (scale / 2),
        height: bb.height * (scale / 2)
      }
    };
  },

  getMouseUpElementData: function (event) {
    var bb = svgedit.utilities.getBBox(this.$draggableClone.find('svg path')[0]);
    var draggableBox = this.$draggableClone.get(0).getBoundingClientRect();
    var zoom = EditorFacade.handle('zoom', 'get');
    var offset = this.editor.getOffset();
    var scale = Math.min(this.canvas.contentW, this.canvas.contentH) / Math.max(bb.width, bb.height);

    var position = $(event.target).parents('.root-popupmenu').length ?
    {
      x: (this.canvas.contentW - bb.width * (scale / 4)) / 2,
      y: (this.canvas.contentH - bb.height * (scale / 4)) / 2
    } : {
      x: Math.floor4((draggableBox.left - offset.x) / zoom),
      y: Math.floor4((draggableBox.top - offset.y) / zoom)
    };

    var size = {
      width: Math.floor4(bb.width * (scale / 4)),
      height: Math.floor4(bb.height * (scale / 4))
    };

    return {
      position: position,
      size: size,
      selected: true
    };
  },

  initialize: function (options) {
    if (options.width) {
      this.width = options.width;
    }

    if (options.height) {
      this.height = options.height;
    }

    this.item = options.item;
    var theme = INKIVE.C.WHITE_LABEL_CONFIGURATION && INKIVE.C.WHITE_LABEL_CONFIGURATION.theme;

    if (theme) {
      this.strokeColor = this.fillColor = (theme === 'dark' ? '#D6D6D6' : '#585858');
    }

    BaseView.prototype.initialize.call(this);
  },

  getTemplateRenderData: function () {
    return {
      path: this.item.path,
      size: this.width,
      view_box: this.getViewBox(),
      stroke_width: 1,
      stroke: this.strokeColor,
      fill: this.fillColor
    };
  },

  getViewBox: function () {
    var size = this.item.size;
    var offset = size * 0.05;

    return [-offset, -offset, size + offset * 2, size + offset * 2].join(' ');
  }
});
